'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (text, options) {
  var entities = (0, _extractUrlsWithIndices2.default)(text, options).concat((0, _extractMentionsOrListsWithIndices2.default)(text)).concat((0, _extractHashtagsWithIndices2.default)(text, { checkUrlOverlap: false })).concat((0, _extractCashtagsWithIndices2.default)(text));

  if (entities.length == 0) {
    return [];
  }

  (0, _removeOverlappingEntities2.default)(entities);
  return entities;
};

var _extractCashtagsWithIndices = require('./extractCashtagsWithIndices');

var _extractCashtagsWithIndices2 = _interopRequireDefault(_extractCashtagsWithIndices);

var _extractHashtagsWithIndices = require('./extractHashtagsWithIndices');

var _extractHashtagsWithIndices2 = _interopRequireDefault(_extractHashtagsWithIndices);

var _extractMentionsOrListsWithIndices = require('./extractMentionsOrListsWithIndices');

var _extractMentionsOrListsWithIndices2 = _interopRequireDefault(_extractMentionsOrListsWithIndices);

var _extractUrlsWithIndices = require('./extractUrlsWithIndices');

var _extractUrlsWithIndices2 = _interopRequireDefault(_extractUrlsWithIndices);

var _removeOverlappingEntities = require('./removeOverlappingEntities');

var _removeOverlappingEntities2 = _interopRequireDefault(_removeOverlappingEntities);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

module.exports = exports['default'];